module.exports = __webpack_public_path__ + "static/media/trunk_picture.af473242.jpg";